import { Link } from 'react-router-dom';

import { Shell } from '../components/Shell';

export function NotFoundPage() {
  return (
    <Shell>
      <div className="center-state">
        <h1>Nothing here</h1>
        <p>
          That address does not match a page. Session links look like{' '}
          <code>/s/aB3xK9dQr2M</code>.
        </p>
        <Link className="btn" to="/">
          Back to the start
        </Link>
      </div>
    </Shell>
  );
}
